import React from 'react';
import {Grid} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid-pro';
import {Panel} from '../../components/Panel/Panel';
import {themeColors} from '../../theme/Theme';
import Loading from '../../components/Loading/Loading';
import {useTableStyles} from '../../components/useTableStyles';
import {
  renderCellFileName,
  renderCellURL,
} from '../ClientDocumentsPageV2/ClientDocumentsPageV2';
import useSPPFiles from './useSPPFiles';
import useTitle from '../../hooks/useTitle';
import {StickyDataGrid} from '../../components/Common/StickyDataGrid';
import {SaltusAny} from '../../utils/SaltusAny';

const cfColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Document Name',
    flex: 1.5,
    editable: false,
    sortable: false,
    renderCell: renderCellFileName,
  },
  {
    field: 'documentType',
    headerName: 'Document Type',
    flex: 1,
    editable: false,
    sortable: false,
    valueFormatter: (value: SaltusAny) => value ?? 'N/A',
  },
  {
    field: 'url',
    headerName: 'Download',
    flex: 1,
    editable: false,
    sortable: false,
    renderCell: renderCellURL,
  },
];

function SPPDocumentsPage() {
  const classes = useTableStyles();
  const {sppClientFiles, sppClientFilesError, sppClientFilesLoading} = useSPPFiles();
  useTitle(`SPP Documents`);

  if (sppClientFilesLoading) {
    return <Loading />;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Panel
          title="SPP Documents"
          style={{
            height: '100%',
          }}
          color={themeColors.lightAlert}
        >
          <StickyDataGrid
            columns={cfColumns}
            rows={!sppClientFilesError ? sppClientFiles : []} // swallowing common error: "Folder ID does not exist for account with curo_id..."
            rowHeight={60}
            sortModel={[{field: 'createdAt', sort: 'desc'}]}
            sx={{
              ...classes.table,
              ...classes.hideColumnMenu,
            }}
          />
        </Panel>
      </Grid>
    </Grid>
  );
}

export default SPPDocumentsPage;
